export const METRICS_PAGE_ID = 'jira-spa-apps-servicedesk-calendar';
export const UFO_SUFFIX_KEY = 'servicedesk';
export const TEAM_NAME = 'jsd-shield';
